import type { SquadArchetype } from '../entities/Squad.js';
import type { EntityId, PlayerId, Tick } from '../ids.js';

import type { CommandBase } from './Command.js';

export interface ProduceSquadCommand extends CommandBase {
  kind: 'produce_squad';
  producerId: EntityId;
  archetype: SquadArchetype;
}

export function makeProduceSquadCommand(args: {
  issuedBy: PlayerId;
  tick: Tick;
  producerId: EntityId;
  archetype: SquadArchetype;
}): ProduceSquadCommand {
  return {
    kind: 'produce_squad',
    issuedBy: args.issuedBy,
    tick: args.tick,
    producerId: args.producerId,
    archetype: args.archetype,
  };
}
